// CardNet Purchase Service
// Minimal implementation for Cloud Function integration

import { getFunctions, httpsCallable } from 'firebase/functions';

export class CardNetPurchaseService {
  static async processPurchase(data: any): Promise<any> {
    const functions = getFunctions();
    const processPayment = httpsCallable(functions, 'processPayment');
    
    const result = await processPayment(data);
    return result.data;
  }
}
